module.exports = __webpack_public_path__ + "img/Citrus_maxima.199b6ba5.jpg";